const currency = new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD', maximumFractionDigits: 0,
});

export function formatCurrency(value) {
  return Number.isFinite(value) ? currency.format(value) : '—';
}

export function formatPercent(fraction) {
  if (!Number.isFinite(fraction)) return '—';
  const pct = fraction * 100;
  return `${Number.isInteger(pct) ? pct : pct.toFixed(1)}%`;
}

// risk scores are 0..1 where higher = stronger; show as 0-100
export function formatScore(score) {
  return Number.isFinite(score) ? String(Math.round(score * 100)) : '—';
}

export const STATUS_LABELS = {
  ok: 'Calculated',
  insufficient_data: 'Needs more data',
  negative_result: 'Negative result',
  excluded: 'Excluded',
  not_implemented: 'Not available',
};
